<template>
  <div :class="$style.welfare">
    <div :class="$style.header">
      <span>{{ title }}</span>
      <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt @click="$emit('close')" />
    </div>
    <div :class="$style.tab" v-show="tabs.length > 1">
      <ul>
        <li
          v-for="(item, index) in tabs"
          :key="index"
          :class="[tabActive === index ? $style.active : '', $style.tabItem]"
          @click="setTabActive(index)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
    <component :is="currentComponent" :class="$style.list"></component>
  </div>
</template>

<script>
import Voucher from './Voucher.vue';
import Gift from './Gift.vue';
import RedEnvelope from './RedEnvelope';
import { getStorage } from '@/libs/utils';
import { mapState } from 'vuex';

export default {
  name: '',
  data() {
    return {
      tabs: [],
      tabActive: 0,
      currentComponent: '',
      title: '福利',
    };
  },
  mounted() {
    this.initTabs();
  },
  computed: {
    ...mapState({
      normal_gift: state => state.suspend.normal_gift || [],
      game_gift: state => state.suspend.game_gift || [],
    }),
  },
  methods: {
    initTabs() {
      const { benefit_list } = this.$store.state.suspend;
      const activity_status = getStorage('activity_status');
      const boxStatus = getStorage('box_status');
      this.tabs = benefit_list.map((item) => {
        if (item == 1) {
          return {
            name: '代金券',
            type: 'voucher',
          };
        } else if (item == 2) {
          return {
            name: '礼包',
            type: 'gift',
          };
        }
      });
      const hasGiftTab = this.tabs.find((item) => item.type === 'gift');
      if ((boxStatus != 0 || this.normal_gift.length || this.game_gift.length) && !hasGiftTab) {
        this.tabs.unshift({
          name: '礼包',
          type: 'gift',
        });
      }
      if (activity_status == 1) {
        this.tabs.unshift({
          name: '红包',
          type: 'redPacket',
        });
      }
      if (this.tabs.length === 1) {
        this.title = this.tabs[0].name;
      }
      setTimeout(() => {
        this.setTabActive();
      }, 200);
    },
    setTabActive(index = 0) {
      this.tabActive = index;
      this.cardList = [];
      this.setComponent();
    },
    setComponent() {
      if (this.tabs[this.tabActive].type == 'gift') {
        this.currentComponent = Gift;
      } else if (this.tabs[this.tabActive].type == 'voucher') {
        this.currentComponent = Voucher;
      } else if (this.tabs[this.tabActive].type == 'redPacket') {
        this.currentComponent = RedEnvelope;
      }
    },
  },
  components: {
    Voucher,
    Gift,
    RedEnvelope,
  },
};
</script>

<style lang="scss" module>
@import '../common.scss';

.welfare {
  @include common-h5-wrap();
  position: relative;
  .header {
    margin-bottom: 2px;
  }
  .tab {
    position: relative;
    > ul {
      display: flex;
      padding: 2px 18px 4px;
      justify-content: space-around;
      .tabItem {
        font-size: 11px;
        color: #8b8b8b;
        margin-right: 21px;
        padding: 0 10px;
        padding-bottom: 3px;
        &.active {
          color: #ff5b58;
          font-weight: 400;
          border-bottom: 2px solid #ff5955;
        }
      }
    }
  }
  .list {
    height: calc(100% - 65px);
  }
}
</style>
